import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { NgxPanelComponent } from './panel.component';

export const ngxPanelModule = angular.module('ngxPanelModule', [])
	.directive('ngxPanel', downgradeComponent({ component: NgxPanelComponent }))
	.name;
